__turbopack_context__.v({
  "NossoAcervoDetalhes": "x5hSWq_NossoAcervoDetalhes",
  "acervoImagemEFlags": "x5hSWq_acervoImagemEFlags",
  "autor": "x5hSWq_autor",
  "autorLivro": "x5hSWq_autorLivro",
  "bgDireita": "x5hSWq_bgDireita",
  "bgEsquerda": "x5hSWq_bgEsquerda",
  "bold": "x5hSWq_bold",
  "containerImgFlags": "x5hSWq_containerImgFlags",
  "containerLivrosSimilares": "x5hSWq_containerLivrosSimilares",
  "contentAcervo": "x5hSWq_contentAcervo",
  "dFlex": "x5hSWq_dFlex",
  "descricaoAcervo": "x5hSWq_descricaoAcervo",
  "epub": "x5hSWq_epub",
  "imgAcervo": "x5hSWq_imgAcervo",
  "imgAcervoBook": "x5hSWq_imgAcervoBook",
  "imgBox": "x5hSWq_imgBox",
  "infoLivroAcervo": "x5hSWq_infoLivroAcervo",
  "itemAcervo": "x5hSWq_itemAcervo",
  "itemFlag": "x5hSWq_itemFlag",
  "itemLivroSimilar": "x5hSWq_itemLivroSimilar",
  "livrosSimilares": "x5hSWq_livrosSimilares",
  "novo": "x5hSWq_novo",
  "pdf": "x5hSWq_pdf",
  "sobreAutor": "x5hSWq_sobreAutor",
  "sobreLivro": "x5hSWq_sobreLivro",
  "title": "x5hSWq_title",
  "tituloLivro": "x5hSWq_tituloLivro",
  "uiContainer": "x5hSWq_uiContainer",
});
